<template>
  <v-row>
    <v-col cols="12" v-if="!profiles || !profiles.length">
      <v-alert :value="true" type="warning">No profiles configured!</v-alert>
    </v-col>
    <v-col cols="12" v-if="profiles && !selectedIdentityProfile && !detailIdentityProfile && !validateIdentityProfile">
      <v-row>
        <v-col
          class="d-flex child-flex"
          v-for="profile in profiles" :key="profile.id"
          cols="12" sm="6" md="4" lg="3" xl="2">
          <v-card
            class="flexcard"
            style="display:flex;flex-direction:column;"
            height="100%"
            :dark="darkBackgroundColors.includes(profile.color) ? false : true"
            :color="profile.color">
            <v-card-title>
              <v-icon large left>{{profile.icon}}</v-icon>
              <span class="title font-weight-light">{{profile.name}}</span>
            </v-card-title>
            <v-card-text class="grow">{{profile.description}}</v-card-text>
            <v-card-actions>
              <v-row align="end" justify="end">
                <v-btn class="ma-2" v-if="me.person.isEditor" icon @click="newIdentity(profile)">
                  <v-icon>add</v-icon>
                </v-btn>
                <v-btn class="ma-2" icon @click="selectedProfile = profile">
                  <v-icon>list</v-icon>
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <identityList
        v-if="profiles && profiles.length > 0 && !selectedIdentityProfile && !detailIdentityProfile && !validateIdentityProfile"
        :identities="identities"
        :profiles="profiles"
        :me="me"
        :selectedProfile="selectedProfile"
        v-on:done="getData"
        v-on:dates="setSelectedDates"
      ></identityList>
    </v-col>
    <v-col cols="12" xl="6" lg="9" md="12">
      <identityForm 
        v-if="selectedIdentityProfile" 
        :identity="selectedIdentity" 
        :me="me"
        :groupEditChoice="groupEditChoice"
        v-on:done="getData"
      ></identityForm>
      <identityFormDetail
        v-if="detailIdentityProfile"
        :identity="detailIdentity"
        :me="me"
        v-on:done="getData"
      ></identityFormDetail>
    </v-col>
    <v-col cols="12">
      <identityFormValidate
        v-if="validateIdentityProfile"
        :identity="validateIdentity"
        :me="me"
        v-on:done="getData"
      ></identityFormValidate>
    </v-col>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog
      v-model="print"
      max-width="360px"
      persistent 
    >
      <v-card>
        <v-card-title>De dagpas is gereed. /<br />
        The Daypass is ready.</v-card-title>
        <v-card-text>
          <pdf style="border: 1px solid red"
            v-if="pdftemp"
            ref="pdf" 
            :src="pdftemp"
          ></pdf>
        </v-card-text>
        <v-divider></v-divider>
        <br />
        <v-card-text>
          <v-btn class="float-right" @click="cancelPdf()">cancel</v-btn>
          <v-btn color="primary" @click="printPdf()">print</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import identityForm from "../components/IdentityForm.vue";
import identityFormDetail from "../components/IdentityFormDetail.vue";
import identityFormValidate from "../components/IdentityFormValidate.vue";
import identityList from "../components/IdentityList.vue";
import pdf from "vue-pdf";
export default {
  name: "Home",
  props: ["me"],
  components: {
    identityForm,
    identityFormDetail,
    identityFormValidate,
    identityList,
    pdf
  },
  data() {
    return {
      profiles: [],
      selectedIdentity: {},
      selectedProfile: null,
      groupEditChoice: 0,
      detailIdentity: {},
      validateIdentity: {},
      identities: [],
      selectedDates: [],
      darkBackgroundColors: ["white", "yellow", "lime"],
      loading: true,
      print: false,
      processorResult: null,
      pdftemp: null,
    };
  },
  watch: {
    selectedProfile() {
      this.showList();
    },
    processorResult() {
      if (this.processorResult) {
        this.loading = false;
        if (this.processorResult.status == 0) {
          if (this.processorResult.dataType == 1) {
            var tempdata = 'data:application/pdf;base64,' + this.processorResult.data;
            this.pdftemp = this.convertDataURIToBinary(tempdata);
            this.print = true;
          }
          else if (this.processorResult.dataType == 4 && this.processorResult.message == "GroupId")
            this.selectedIdentity.groupProfileId = this.processorResult.data;
          else {
            this.processorResult = null;
            this.getData();
          }
        }
      }
    }
  },
  computed: {
    selectedIdentityProfile() {
      if (!this.selectedIdentity) return null;
      if (!this.selectedIdentity.profile) return null;
      if (this.selectedIdentity.profile == {}) return null;
      return this.selectedIdentity.profile;
    },
    detailIdentityProfile() {
      if (!this.detailIdentity) return null;
      if (!this.detailIdentity.profile) return null;
      if (this.detailIdentity.profile == {}) return null;
      return this.detailIdentity.profile;
    },
    validateIdentityProfile() {
      if (!this.validateIdentity) return null;
      if (!this.validateIdentity.profile) return null;
      if (this.validateIdentity.profile == {}) return null;
      return this.validateIdentity.profile;
    }
  },
  methods: {
    newIdentity(profile) {
      if (profile != null) {
        this.setProfileFilter(profile.id);
      }
      let newIdentity = {
        id: null,
        startDate: null,
        endDate: null,
        profile: profile
      };
      this.groupEditChoice = 0;
      this.selectedIdentity = newIdentity;
    },
    setSelectedDates(dates) {
      if (dates) {
        this.selectedDates = dates;
      }
      this.showList();
    },
    cancelPdf() {
      this.processorResult = null;
      this.print = false;
      this.getData();
    },
    printPdf() {
      this.$refs.pdf.print(300,[1]);
      this.cancelPdf();
    },
    convertDataURIToBinary(dataURI) {
      var BASE64_MARKER = ';base64,';
      var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      var base64 = dataURI.substring(base64Index);
      var raw = window.atob(base64);
      var rawLength = raw.length;
      var array = new Uint8Array(new ArrayBuffer(rawLength));
      for (var i = 0; i < rawLength; i++) {
         array[i] = raw.charCodeAt(i);
      }
      return array;
    },
    getData() {
      this.newIdentity(null);
      this.selectedIdentity = {};
      this.detailIdentity = {};
      this.validateIdentity = {};
        this.$http
          .get("api/identityprofiles/dashboard")
          .then(request => {
            if (request.data && request.data.length > 0) {
              this.profiles = request.data;
              this.selectedProfile = this.profiles.find(x => x.id === this.getProfileFilter());
              if (!this.selectedProfile && this.profiles) this.selectedProfile = this.profiles[0];
            } else {
              this.loading = false;
            }
          })
          .catch(err => {
            this.$root.$children[0].$emit("display-error", "1200", err);
            this.loading = false;
          });
    },
    setProfileFilter(value) {
      localStorage.setItem("defaultprofile", JSON.stringify(value));
    },
    getProfileFilter() {
      if (localStorage.getItem("defaultprofile")) {
        var id = JSON.parse(localStorage.getItem("defaultprofile"));
        if (this.profiles.find(p => p.id === id)) {
          return id
        } else {
          return null
        }
      }
    },
    showList() {
      if (this.selectedProfile) {
        this.setProfileFilter(this.selectedProfile.id);
        this.loading = true;
        let query = "?start=";
        if (this.selectedDates && this.selectedDates.length > 0) {
          query += this.selectedDates[0];
          if (this.selectedDates.length > 1) {
            query += "&end=" + this.selectedDates[1];
          }
        }
        this.$http
          .get("api/identities/profile/" + this.selectedProfile.id + query)
          .then(request => {
            if (request.data && request.data.length > 0) {
              this.identities = request.data;
            } else {
              this.identities = null;
              this.noResultMessage = "No identities found for today";
            }
            this.loading = false;
          })
          .catch(err => {
            this.$root.$children[0].$emit("display-error", "1201", err);
            this.loading = false;
          });
      }  
      this.backButton = false;
    }
  },
  mounted() {
    this.getData();
    if (this.$root.$children[0]) this.$root.$children[0].getMe();
  }
};
</script>